"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _react = require("react");

var localStoragePrefix = "ged_";

var _default = function _default(hookName, defaultValue) {
  var storeValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var subscribers = [];
  var value = defaultValue;

  if (storeValue && localStorage.getItem("".concat(localStoragePrefix).concat(hookName))) {
    try {
      value = JSON.parse(localStorage.getItem("".concat(localStoragePrefix).concat(hookName)));
    } catch (_unused) {
      value = localStorage.getItem("".concat(localStoragePrefix).concat(hookName));
    }
  }

  var subscribe = function subscribe(action) {
    if (typeof action === "function") {
      subscribers.push(action);
    }
  };

  var unsubscribe = function unsubscribe(action) {
    subscribers = subscribers.filter(function (s) {
      return s !== action;
    });
  };

  var CustomHook = function CustomHook() {
    (0, _classCallCheck2["default"])(this, CustomHook);
  };

  CustomHook["set".concat(hookName)] = function (v) {
    value = v;

    if (storeValue) {
      localStorage.setItem("".concat(localStoragePrefix).concat(hookName), (0, _typeof2["default"])(v) === "object" ? JSON.stringify(v) : v);
    }

    subscribers.forEach(function (action) {
      return action(value);
    });
  };

  CustomHook["get".concat(hookName)] = function () {
    return value;
  };

  CustomHook["use".concat(hookName)] = function () {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _useState = (0, _react.useState)(value),
        _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
        currentValue = _useState2[0],
        setCurrentValue = _useState2[1]; // eslint-disable-next-line react-hooks/rules-of-hooks


    (0, _react.useEffect)(function () {
      var handleValueChange = function handleValueChange(v) {
        setCurrentValue(v);
      };

      subscribe(handleValueChange);
      return function () {
        unsubscribe(handleValueChange);
      };
    });
    return [currentValue, CustomHook["set".concat(hookName)]];
  }; // class CustomHook {
  //   static [`set${hookName}`] = v => {
  //     value = v;
  //     subscribers.forEach(action => action(value));
  //   };
  //   static [`get${hookName}`] = () => value;
  //   static [`use${hookName}`] = () => {
  //     const [currentValue, setCurrentValue] = useState(value);
  //     useEffect(() => {
  //       const handleValueChange = v => {
  //         setCurrentValue(v);
  //       };
  //       subscribe(handleValueChange);
  //       return () => {
  //         unsubscribe(handleValueChange);
  //       };
  //     });
  //     return [currentValue, CustomHook[`set${hookName}`]];
  //   };
  // }


  return CustomHook;
};

exports["default"] = _default;